import { ClubImportRow } from "@/components/features/ClubImport/ClubImportRow";
import { useTranslation } from "@repo/shared/i18n";

const CLUB_IMPORT_ORIGIN = { section: "SBC", subsection: "Set View" };

/**
 * The club row of a set's toolbar: a solve reads the club, so there is no
 * pool to pick — only a club to bring in, and a line saying what Solve will
 * then do with it. Streamline sets and normal sets share it.
 */
export const StreamlineSolveRow = ({ isTouch }: { isTouch: boolean }) => {
  const { t } = useTranslation("sbcs");
  return (
    <ClubImportRow
      isTouch={isTouch}
      origin={CLUB_IMPORT_ORIGIN}
      importLabel={t("streamline.cheapestCombination.importButton")}
      importedLabel={t("streamline.cheapestCombination.importedButton")}
      pitch={t("streamline.cheapestCombination.solvePitch")}
    />
  );
};
